import Vue from 'vue'
import Router from 'vue-router'

const Full = () => import('@/containers/Full')
const PrintWorkOrder = () => import('@/containers/PrintWorkOrder')

const Page500 = () => import('@/views/error/Page500')
const Page404 = () => import('@/views/error/Page404')
const Page403 = () => import('@/views/error/Page403')
const Dashboard = () => import('@/views/Dashboard')
const Login = () => import('@/views/login/Login')
const Qlik = () => import('@/views/Qlik')
const Logout = () => import('@/views/logout/Logout')
const EquipmentIndex = () => import('@/views/equipment/Index')
const EquipmentHistorical = () => import('@/views/equipment/Historical')
const JointIndex = () => import('@/views/joint/Index')
const JointIndexMachine = () => import('@/views/joint/IndexMachine')
const SupportIndex = () => import('@/views/support/Index')
const JointPrintReport = () => import('@/views/joint/PrintReport')
const UserProfile = () => import('@/views/user/Profile')
const NewWorkOrder = () => import('@/views/workorder/New')
const SingleWorkOrder = () => import('@/views/workorder/edit/Index')
const WorkOrderIndex = () => import('@/views/workorder/Index')
const WorkOrderJobReporting = () => import('@/views/workorder/JobReporting')
const WorkOrderReadyForInvoicing = () => import('@/views/workorder/ReadyForInvoicing')
const WorkOrderPrinted = () => import('@/views/workorder/Printed')
const WorkOrderMine = () => import('@/views/workorder/Mine')
const WorkOrderDelete = () => import('@/views/workorder/Delete')
const NewPicklist = () => import('@/views/picklist/New')
const SinglePicklist = () => import('@/views/picklist/edit/Index')
const PicklistIndex = () => import('@/views/picklist/Index')
const PicklistPrinted = () => import('@/views/picklist/Printed')
const PicklistDraft = () => import('@/views/picklist/Draft')
const PicklistDelete = () => import('@/views/picklist/Delete')
const FoamIndex = () => import('@/views/foam/Index')
const NewRental = () => import('@/views/rental/NewRental')
const EditRental = () => import('@/views/rental/EditRental')
const RentalIndex = () => import('@/views/rental/Index')
const RentalEquipment = () => import('@/views/rental/Equipment')
const RentalEquipmentEdit = () => import('@/views/rental/EditEquipment')
const RentalEquipmentDelete = () => import('@/views/rental/DeleteEquipment')
const RentalEquipmentModel = () => import('@/views/rental/EquipmentModel')
const RentalDeleteEquipmentModel = () => import('@/views/rental/DeleteEquipmentModel')
const RentalEditEquipmentModel = () => import('@/views/rental/EditEquipmentModel')
const RentalEquipmentType = () => import('@/views/rental/EquipmentType')
const RentalDeleteEquipmentType = () => import('@/views/rental/DeleteEquipmentType')
const RentalEditEquipmentType = () => import('@/views/rental/EditEquipmentType')
const RentalDelete = () => import('@/views/rental/DeleteRental')
const NewFlata = () => import('@/views/flata/NewFlata')
const EditFlata = () => import('@/views/flata/EditFlata')
const FlataIndex = () => import('@/views/flata/Index')
const KnowledgeBaseIndex = () => import('@/views/knowledgebase/Index')
const AdminCustomerLog = () => import('@/views/admin/CustomerLog')
const AdminEmailTemplate = () => import('@/views/admin/EmailTemplate')
const AdminEditEmailTemplate = () => import('@/views/admin/EditEmailTemplate')
const AdminRevisions = () => import('@/views/admin/Revisions')
const AdminRevisionDelete = () => import('@/views/admin/DeleteRevision')
const AdminEquipmentSpecification = () => import('@/views/admin/EquipmentSpecification')
const AdminUpdateQueue = () => import('@/views/admin/UpdateQueue')
const AdminDeleteUpdateQueue = () => import('@/views/admin/DeleteUpdateQueue')
const AdminEditEquipmentSpecification = () => import('@/views/admin/EditEquipmentSpecification')
const AdminUsers = () => import('@/views/admin/Users')
const AdminEditUser = () => import('@/views/admin/EditUser')
const AdminDeleteUser = () => import('@/views/admin/DeleteUser')
const AdminArticles = () => import('@/views/admin/Articles')
const AdminEditArticle = () => import('@/views/admin/EditArticle')
const AdminDeleteArticle = () => import('@/views/admin/DeleteArticle')
const AdminCustomers = () => import('@/views/admin/Customers')
const AdminEditCustomer = () => import('@/views/admin/EditCustomer')
const AdminDeleteCustomer = () => import('@/views/admin/DeleteCustomer')
const AdminEditCustomerContact = () => import('@/views/admin/EditCustomerContact')
const AdminDeleteCustomerContact = () => import('@/views/admin/DeleteCustomerContact')
const Blueprint = () => import('@/views/blueprint/Blueprint')
const AdminFoamWeighing = () => import('@/views/admin/FoamWeighing')
const AdminQuickAdd = () => import('@/views/admin/QuickAdd')
const AdminEditQuickAdd = () => import('@/views/admin/EditQuickAdd')
const AdminDeleteQuickAdd = () => import('@/views/admin/DeleteQuickAdd')

const QlikLoginReturn = () => import('@/views/QlikLoginReturn')

Vue.use(Router)

export default new Router({
  mode: 'history',
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '/print/workorder/:id',
      name: 'Print Work Order',
      component: PrintWorkOrder
    },
    {
      path: '/',
      redirect: '/dashboard',
      name: 'Home',
      component: Full,
      children: [
        {
          path: 'logout',
          name: 'Logout',
          meta: { auth: undefined },
          component: Logout
        },
        {
          path: 'login',
          name: 'Login',
          meta: { auth: false },
          component: Login
        },
        {
          path: 'qlik',
          name: 'Qlik',
          meta: { auth: ['admin'] },
          component: Qlik
        },
        {
          path: '/admin/users/',
          name: 'Admin',
          meta: { auth: ['admin'] },
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: '/admin/users',
              name: 'Users',
              meta: { auth: ['admin'] },
              component: AdminUsers
            },
            {
              path: '/admin/users/edit/:id',
              name: 'Edit User',
              meta: { auth: ['admin'] },
              component: AdminEditUser
            },
            {
              path: '/admin/users/delete/:id',
              name: 'Delete User',
              meta: { auth: ['admin'] },
              component: AdminDeleteUser
            },
            {
              path: '/customerlog',
              name: 'Customer Log',
              meta: { auth: ['admin'] },
              component: AdminCustomerLog
            },
            {
              path: '/admin/emailtemplate',
              name: 'Email Template',
              meta: { auth: ['admin'] },
              component: AdminEmailTemplate
            },
            {
              path: '/admin/emailtemplate/edit/:id',
              name: 'Edit Email Template',
              meta: { auth: ['admin'] },
              component: AdminEditEmailTemplate
            },
            {
              path: '/admin/articles',
              name: 'Articles',
              meta: { auth: ['admin'] },
              component: AdminArticles
            },
            {
              path: '/admin/articles/edit/:id',
              name: 'Edit Article',
              meta: { auth: ['admin'] },
              component: AdminEditArticle
            },
            {
              path: '/admin/articles/delete/:id',
              name: 'Delete Article',
              meta: { auth: ['admin'] },
              component: AdminDeleteArticle
            },
            {
              path: '/admin/customers',
              name: 'Customers',
              meta: { auth: ['admin'] },
              component: AdminCustomers
            },
            {
              path: '/admin/customers/edit/:id',
              name: 'Edit Customer',
              meta: { auth: ['admin'] },
              component: AdminEditCustomer
            },
            {
              path: '/admin/customers/delete/:id',
              name: 'Delete Customer',
              meta: { auth: ['admin'] },
              component: AdminDeleteCustomer
            },
            {
              path: '/admin/customers/edit/:id/edit/:contact_id',
              name: 'Edit Customer Contact',
              meta: { auth: ['admin'] },
              component: AdminEditCustomerContact
            },
            {
              path: '/admin/customers/edit/:id/delete/:contact_id',
              name: 'Delete Customer Contact',
              meta: { auth: ['admin'] },
              component: AdminDeleteCustomerContact
            },
            {
              path: '/admin/revisions',
              name: 'Revisions',
              meta: { auth: ['admin'] },
              component: AdminRevisions
            },
            {
              path: '/admin/revisions/delete/:id',
              name: 'Delete Revision',
              meta: { auth: ['admin'] },
              component: AdminRevisionDelete
            },
            {
              path: '/admin/equipment_specification',
              name: 'Equipment Specification',
              meta: { auth: ['admin'] },
              component: AdminEquipmentSpecification
            },
            {
              path: '/admin/equipment_specification/edit/:id',
              name: 'Edit Equipment Specification',
              meta: { auth: ['admin'] },
              component: AdminEditEquipmentSpecification
            },
            {
              path: '/admin/update_queue',
              name: 'Update Queue',
              meta: { auth: ['admin'] },
              component: AdminUpdateQueue
            },
            {
              path: '/admin/update_queue/delete/:id',
              name: 'Delete Update Queue',
              meta: { auth: ['admin'] },
              component: AdminDeleteUpdateQueue
            },
            {
              path: '/admin/foam_weighing',
              name: 'Foam Weighing',
              meta: { auth: ['admin'] },
              component: AdminFoamWeighing
            }
          ]
        },
        {
          path: '/admin/quickadd',
          name: 'Quick Add',
          component: AdminQuickAdd,
          meta: { requiresAuth: true }
        },
        {
          path: '/admin/quickadd/edit/:id',
          name: 'Edit Quick Add',
          meta: { auth: ['admin'] },
          component: AdminEditQuickAdd
        },
        {
          path: '/admin/quickadd/delete/:id',
          name: 'Delete Quick Add',
          meta: { auth: ['admin'] },
          component: AdminDeleteQuickAdd
        },
        {
          path: 'dashboard',
          name: 'Dashboard',
          meta: { auth: ['joint', 'admin', 'workorder', 'shop'] },
          component: Dashboard
        },
        {
          path: '/workorder/',
          name: 'Work Orders',
          redirect: '/workorder/list',
          meta: { auth: ['admin', 'workorder'] },
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: '/workorder/list',
              name: 'Work Order List',
              meta: { auth: ['admin', 'workorder'] },
              component: WorkOrderIndex
            }, {
              path: '/workorder/new',
              name: 'New',
              meta: { auth: ['admin', 'workorder'] },
              component: NewWorkOrder
            }, {
              path: '/workorder/mine',
              name: 'Mine',
              meta: { auth: ['admin', 'workorder'] },
              component: WorkOrderMine
            }, {
              path: '/workorder/jobreporting',
              name: 'Job Reporting',
              meta: { auth: ['admin', 'workorder'] },
              component: WorkOrderJobReporting
            }, {
              path: '/workorder/readyforinvoicing',
              name: 'Ready For Invoicing',
              meta: { auth: ['admin', 'workorder'] },
              component: WorkOrderReadyForInvoicing
            }, {
              path: '/workorder/printed',
              name: 'Printed',
              meta: { auth: ['admin', 'workorder'] },
              component: WorkOrderPrinted
            }, {
              path: '/workorder/delete/:id',
              name: 'Delete Work Order',
              meta: { auth: ['admin', 'workorder'] },
              component: WorkOrderDelete
            }, {
              path: '/workorder/edit/:id/:tab?',
              name: 'Single Work Order',
              meta: { auth: ['admin', 'workorder'], label: 'Order #' },
              component: SingleWorkOrder
            }
          ]
        },
        {
          path: '/picklist/',
          name: 'Picklist',
          redirect: '/picklist/list',
          meta: { auth: ['admin', 'picklist'] },
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: '/picklist/list',
              name: 'Picklist List',
              meta: { auth: ['admin', 'picklist'] },
              component: PicklistIndex
            }, {
              path: '/picklist/new',
              name: 'New',
              meta: { auth: ['admin', 'picklist'] },
              component: NewPicklist
            }, {
              path: '/picklist/draft',
              name: 'Draft',
              meta: { auth: ['admin', 'picklist'] },
              component: PicklistDraft
            }, {
              path: '/picklist/printed',
              name: 'Printed',
              meta: { auth: ['admin', 'picklist'] },
              component: PicklistPrinted
            }, {
              path: '/picklist/delete/:id',
              name: 'Delete Picklist',
              meta: { auth: ['admin', 'picklist'] },
              component: PicklistDelete
            }, {
              path: '/picklist/edit/:id/:tab?',
              name: 'Single Picklist',
              meta: { auth: ['admin', 'picklist'], label: 'Picklist #' },
              component: SinglePicklist
            }
          ]
        },
        {
          path: 'rental',
          name: 'Rentals',
          redirect: '/rental/list',
          meta: { auth: ['joint', 'admin'] },
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: '/rental/list',
              name: 'All Rentals',
              meta: { auth: ['rentals', 'admin'] },
              component: RentalIndex
            }, {
              path: '/rental/new/:equipment_id?',
              name: 'New Rental',
              meta: { auth: ['rentals', 'admin'] },
              component: NewRental
            }, {
              path: '/rental/list/edit/:id',
              name: 'Edit Rental',
              meta: { auth: ['rentals', 'admin'] },
              component: EditRental
            }, {
              path: '/rental/equipment',
              name: 'Equipment',
              meta: { auth: ['rentals', 'admin'] },
              component: RentalEquipment
            }, {
              path: '/rental/equipment/delete/:id',
              name: 'Delete Equipment',
              meta: { auth: ['rentals', 'admin'] },
              component: RentalEquipmentDelete
            }, {
              path: '/rental/list/delete/:id',
              name: 'Delete Rental',
              meta: { auth: ['rentals', 'admin'] },
              component: RentalDelete
            }, {
              path: '/rental/equipment/edit/:id',
              name: 'Edit Equipment',
              meta: { auth: ['rentals', 'admin'] },
              component: RentalEquipmentEdit
            }, {
              path: '/rental/equipmentmodel',
              name: 'Equipment Model',
              meta: { auth: ['rentals', 'admin'] },
              component: RentalEquipmentModel
            }, {
              path: '/rental/equipmentmodel/delete/:id',
              name: 'Delete Equipment Model',
              meta: { auth: ['rentals', 'admin'] },
              component: RentalDeleteEquipmentModel
            }, {
              path: '/rental/equipmentmodel/edit/:id',
              name: 'Edit Equipment Model',
              meta: { auth: ['rentals', 'admin'] },
              component: RentalEditEquipmentModel
            }, {
              path: '/rental/equipmenttype',
              name: 'Equipment Type',
              meta: { auth: ['rentals', 'admin'] },
              component: RentalEquipmentType
            }, {
              path: '/rental/equipmenttype/delete/:id',
              name: 'Delete Equipment Type',
              meta: { auth: ['rentals', 'admin'] },
              component: RentalDeleteEquipmentType
            }, {
              path: '/rental/equipmenttype/edit/:id',
              name: 'Edit Equipment Type',
              meta: { auth: ['rentals', 'admin'] },
              component: RentalEditEquipmentType
            }
          ]
        },
        {
          path: 'flata',
          name: 'Fläta',
          redirect: '/flata',
          meta: { auth: ['flata', 'admin'] },
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: '/flata',
              name: 'All Fläta',
              meta: { auth: ['flata', 'admin'] },
              component: FlataIndex
            }, {
              path: '/flata/new/',
              name: 'New Flata',
              meta: { auth: ['flata', 'admin'] },
              component: NewFlata
            }, {
              path: '/flata/edit/:id',
              name: 'Edit Flata',
              meta: { auth: ['flata', 'admin'] },
              component: EditFlata
            }
          ]
        },
        {
          path: 'equipment',
          name: 'Equipment',
          redirect: '/equipment/current',
          meta: { auth: ['joint', 'admin'] },
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: '/equipment/current',
              name: 'Current Equipment',
              meta: { auth: ['joint', 'admin'] },
              component: EquipmentIndex
            }, {
              path: '/equipment/historical',
              name: 'Equipment History',
              meta: { auth: ['joint', 'admin'] },
              component: EquipmentHistorical
            }
          ]
        },
        {
          path: 'joint',
          name: 'Joint Log',
          meta: { auth: ['joint', 'admin'] },
          component: JointIndex
        },
        {
          path: 'jointmachine',
          name: 'Joint Log Machine',
          meta: { auth: ['admin'] },
          component: JointIndexMachine
        },
        {
          path: '/knowledgebase',
          name: 'Knowledge Base',
          meta: { auth: ['admin'] },
          component: KnowledgeBaseIndex
        },
        {
          path: 'support',
          name: 'Support',
          meta: { auth: ['joint', 'admin'] },
          component: SupportIndex
        },
        {
          path: 'user',
          redirect: '/user/profile',
          name: 'User',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: '/user/profile',
              name: 'User Profile',
              meta: { auth: ['joint', 'workorder', 'admin'] },
              component: UserProfile
            }
          ]
        },
        {
          path: 'foam',
          name: 'Foam',
          meta: { auth: undefined },
          component: FoamIndex
        },
        {
          path: '404',
          name: 'Page404',
          meta: { auth: undefined },
          component: Page404
        },
        {
          path: '500',
          name: 'Page500',
          meta: { auth: undefined },
          component: Page500
        },
        {
          path: '403',
          name: 'Page403',
          meta: { auth: undefined },
          component: Page403
        },
        {
          path: '/blueprint',
          name: 'Blueprint',
          component: Blueprint,
          meta: { auth: ['admin', 'blueprint'] }
        }
      ]
    },
    {
      path: '/joint/printreport',
      name: 'Joint Print Report',
      meta: { auth: ['joint', 'admin'] },
      component: JointPrintReport
    },
    {
      path: '/qlik/return',
      name: 'Qlik Return',
      component: QlikLoginReturn
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js